module.exports = __webpack_public_path__ + "static/media/trim-car-o.e72230e0.png";